// extracted by mini-css-extract-plugin
export default {"container":"LinkTo_container__jCert"};